/**
 * 카테고리 관련 유틸리티 함수
 *
 * categoryId를 기반으로 이모지, 이름 등 카테고리 정보를 반환합니다.
 */

// 1. 카테고리 데이터 타입 정의
export interface Category {
  id: string; // id 타입을 string으로 변경
  emoji: string;
  name_en: string;
  name_kr: string;
}

// 2. 카테고리 데이터 목록
// TODO: 이 부분은 실제 DB의 카테고리 전체 데이터로 채워주세요.
export const CATEGORIES: Category[] = [
  { id: '1', emoji: '🌟', name_en: 'all', name_kr: '전체' },
  { id: '2', emoji: '👥', name_en: 'relationship', name_kr: '인간관계' },
  { id: '3', emoji: '❤️', name_en: 'love', name_kr: '연애' },
  { id: '4', emoji: '💼', name_en: 'work', name_kr: '직장/학교' },
  { id: '5', emoji: '🚀', name_en: 'Future', name_kr: '미래' },
  { id: '6', emoji: '😂', name_en: 'Humor', name_kr: '유머' },
  { id: '7', emoji: '😂', name_en: 'Humor', name_kr: '유머' },
  { id: '8', emoji: '😂', name_en: 'Humor', name_kr: '유머' },
  { id: '9', emoji: '⚽', name_en: 'sport', name_kr: '스포츠' },
  // ... DB에 있는 모든 카테고리를 추가해주세요.
];

// 3. 빠른 조회를 위해 Map 자료구조 생성 (성능 최적화)
const categoryMap = new Map<string, Category>(CATEGORIES.map((cat) => [cat.id, cat]));

// 4. 유틸리티 함수들

/**
 * categoryId로 전체 카테고리 객체를 반환합니다.
 * @param categoryId
 * @returns {Category | undefined}
 */
export const getCategoryById = (categoryId: string): Category | undefined => {
  return categoryMap.get(categoryId);
};

/**
 * categoryId로 카테고리 이모지를 반환합니다.
 * @param categoryId
 * @returns {string} 해당하는 이모지 (없으면 '❓')
 */
export const getCategoryEmoji = (categoryId: string): string => {
  const category = getCategoryById(categoryId);
  console.log('categoryId', categoryId);
  console.log('category', category);
  return category ? category.emoji : '❓';
};

/**
 * categoryId로 카테고리 이름을 반환합니다.
 * @param categoryId
 * @param lang 'kr' 또는 'en' (기본값 'kr')
 * @returns {string} 해당하는 이름 (없으면 'Unknown')
 */
export const getCategoryName = (categoryId: string, lang: 'kr' | 'en' = 'kr'): string => {
  const category = getCategoryById(categoryId);
  if (!category) {
    return 'Unknown Category';
  }
  return lang === 'kr' ? category.name_kr : category.name_en;
};
